import {
  MAIL_SET_THREADS,
  MAIL_APPEND_THREADS,
  MAIL_MERGE_THREADS,
  MAIL_SET_LOADING_MORE,
  MAIL_SET_MESSAGES,
  MAIL_SET_SELECTED,
  MAIL_APPEND_MESSAGE,
  MAIL_SET_LOADING,
  MAIL_UPDATE_THREAD,
  MAIL_SET_ACCOUNTS,
  MAIL_SET_ACCOUNT_MANAGER_OPEN,
  MAIL_WS_CONNECTED,
  MAIL_WS_DISCONNECTED,
  MAIL_DELETE_THREAD,
  MAIL_SET_CHANNEL_UNREADS,
  MAIL_SET_TAB_COUNTS,
} from '../actions/mail'

const initialState = {
  threads: [],
  threadPagination: {},
  loadingMore: false,
  selectedThread: null,
  messages: [],
  loading: false,
  accounts: [],
  accountManagerOpen: false,
  wsConnected: false,
  channelUnreads: { client: 0, partner: 0 },
  tabCounts: { pending: 0, in_progress: 0, resolved: 0 },
}

const appendThreads = (existing, incoming) => {
  const ids = new Set(existing.map(t => t._id))
  const fresh = incoming.filter(t => !ids.has(t._id))
  return [...existing, ...fresh]
}

const mergeThreads = (existing, incoming) => {
  if (!incoming.length) return existing
  const incomingById = new Map(incoming.map(t => [t._id, t]))
  const patched = existing.map(t =>
    incomingById.has(t._id) ? { ...t, ...incomingById.get(t._id) } : t
  )
  const existingIds = new Set(existing.map(t => t._id))
  const newOnes = incoming.filter(t => !existingIds.has(t._id))
  return [...newOnes, ...patched]
}

const mail = (state = initialState, action) => {
  switch (action.type) {
    case MAIL_SET_THREADS:
      return {
        ...state,
        threads: action.payload.threads,
        threadPagination: action.payload.pagination,
      }

    case MAIL_APPEND_THREADS:
      return {
        ...state,
        threads: appendThreads(state.threads, action.payload.threads),
        threadPagination: action.payload.pagination,
      }

    case MAIL_MERGE_THREADS: {
      const prevPages = state.threadPagination?.pages || 0
      const nextPagination = action.payload.pagination || {}
      return {
        ...state,
        threads: mergeThreads(state.threads, action.payload.threads),
        threadPagination: {
          ...nextPagination,
          pages: Math.max(prevPages, nextPagination.pages || 0),
          page: state.threadPagination?.page || nextPagination.page || 1,
        },
      }
    }

    case MAIL_SET_LOADING_MORE:
      return { ...state, loadingMore: action.payload }

    case MAIL_SET_MESSAGES:
      return {
        ...state,
        messages: action.payload,
      }

    case MAIL_SET_SELECTED:
      return {
        ...state,
        selectedThread: action.payload,
        messages: [],
      }

    case MAIL_APPEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      }

    case MAIL_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case MAIL_SET_TAB_COUNTS:
      return {
        ...state,
        tabCounts: {
          pending: action.payload.pending || 0,
          in_progress: action.payload.in_progress || 0,
          resolved: action.payload.resolved || 0,
        },
      }

    case MAIL_UPDATE_THREAD: {
      const updated = action.payload
      const exists = state.threads.some(t => t._id === updated._id)
      return {
        ...state,
        threads: exists
          ? state.threads.map(t =>
              t._id === updated._id ? { ...t, ...updated } : t
            )
          : [updated, ...state.threads],
        selectedThread:
          state.selectedThread && state.selectedThread._id === updated._id
            ? { ...state.selectedThread, ...updated }
            : state.selectedThread,
      }
    }

    case MAIL_DELETE_THREAD: {
      const deletedId = action.payload
      return {
        ...state,
        threads: state.threads.filter(t => t._id !== deletedId),
        selectedThread:
          state.selectedThread && state.selectedThread._id === deletedId
            ? null
            : state.selectedThread,
        messages:
          state.selectedThread && state.selectedThread._id === deletedId
            ? []
            : state.messages,
      }
    }

    case MAIL_SET_ACCOUNTS:
      return {
        ...state,
        accounts: action.payload,
      }

    case MAIL_SET_ACCOUNT_MANAGER_OPEN:
      return {
        ...state,
        accountManagerOpen: action.payload,
      }

    case MAIL_WS_CONNECTED:
      return { ...state, wsConnected: true }

    case MAIL_WS_DISCONNECTED:
      return { ...state, wsConnected: false }

    case MAIL_SET_CHANNEL_UNREADS:
      return { ...state, channelUnreads: action.payload }

    default:
      return state
  }
}

export default mail
